export const pluralise = (word: string): string => `${word}s`;

export const isProductionEnvironment =
  process.env.REACT_APP_WINDDESK_ENVIRONMENT === "production";
